import ParamPropMixin from '../PropsMixins/ParamPropMixin';
export default {
	name: 'IsItemTypeParamMixin',
	mixins: [ParamPropMixin],
	computed: {
		isItemType() {
			return this.param.type === 'item';
		},
	},
};
